import dayjs from "dayjs";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import { useEffect, useState } from "react";
import styled from "@emotion/styled";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Row, Col, Table } from "antd";
import { ColumnsType } from "antd/es/table";
const SwiperTableLayout = styled.div`
  .swiper-table {
    .header {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgcAAAAoCAYAAABqxFnxAAAAAXNSR0IArs4c6QAAA4tJREFUeF7t2dtuVFUcx/G1rKL7NLPLFFNoG9RAone+gWjjgagERfCdbAwh8QIJRo0RBEQuiKcLjadgS8K9JkosyKEy0pnZu7S1tGN2mxgf4rMe4ZPfxTf/FYNHgAABAgQIEPifQCzfOvt07+ovkQoBAgQIECBAIN29NzRx8Ezv2q/iwB4IECBAgACBkE89EWM5c3pf7/pVcWAQBAgQIECAQCgn9oRYzpwTB8ZAgAABAgQIbApsxcHRC/t68789wIQAAQIECBAgkE/sDrE8dv7Z3vwf4sAeCBAgQIAAgZBPPT6M7aOfPde/MS8ODIIAAQIECBAI2dRjw9h++8J0/6Y4sAcCBAgQIEAghGyyiYNjF6ddDsyBAAECBAgQaASyyclhbL9zcbr/57URJAQIECBAgACBbHwzDj5/vn/7ujiwBwIECBAgQCBkOyc2tuLg5o0HeRAgQIAAAQIEsp27NmL7uDgwBQIECBAgQGBLYCsO3v3ihf4tlwOjIECAAAECBELIduzaiK0TX744WLj1EBACBAgQIECAQKszvh5bx796adAVB+ZAgAABAgQIhNAaG1+P6Ymv99/r/uVyYBEECBAgQIBASJvLQfreN/vv3bm9jQcBAgQIECBAIB179H5snfz25cHigjiwBwIECBAgQCCko//FQVccGAQBAgQIECAQ0rHO/Vh8+OMrVXfhYR4ECBAgQIAAgaKzYy0W73/3atX7WxzYAwECBAgQIBDS7aNrsfjg+wPiwBoIECBAgACBRiBtN3Hw0U8Hqrt3HkFCgAABAgQIEEjKzTj44WDVXxQH9kCAAAECBAiEpFX+E4tTlw5Wi92EBwECBAgQIEAgKbevxuL0pdeqxUVxYA8ECBAgQIBAyMvOasw//vn1eiAO7IEAAQIECBAIISnbqzE/NXtIHJgDAQIECBAg0AgkRRMHZ2YP1VUvRUKAAAECBAgQSPLRlZifnX2jripxYA8ECBAgQIBASPL2Ssw/mTtc1+LAHggQIECAAIEQkqy1EvNzc4frQT8DQoAAAQIECBBIinI55mcuH6mXKnFgDwQIECBAgEDIi9ZyzD+9cqSue+LAIAgQIECAAIGQJM23QhMHS/2cBwECBAgQIEAgyYrlmJ+/8ma9NBAH9kCAAAECBAiEzTjYe/nuTBiGp3gQIECAAAECBMJw+Ht8cm7QiSMj23AQIECAAAECBNbD+tq/xSDYp9P2A00AAAAASUVORK5CYII=);
      height: 42px;
      line-height: 42px;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      border-radius: 6px 6px 0px 0px;
      margin-left: 0px !important;
    }
    .body {
      color: #1cfbff !important;
      font-size: 16px;
      min-height: 62px;
      /* line-height: 52px; */
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAX0AAAAgCAYAAAD+HqjMAAAAAXNSR0IArs4c6QAAAXBJREFUeF7t1sFpglEUhNH7FikhQjYRUpYLF7aQRdKuoC2IC38QLMPvvA7m3GF4aw6/+1kfu/EIECBA4L0F1v2y5vT/M9v6eu+k0hEgQIDAPLaz0dcDAgQIVASMfuXSchIgQGDGT18LCBAgUBLw0y9dW1YCBPICRj9fAQAECJQEjH7p2rISIJAXMPr5CgAgQKAkYPRL15aVAIG8gNHPVwAAAQIlAaNfurasBAjkBYx+vgIACBAoCRj90rVlJUAgL2D08xUAQIBAScDol64tKwECeQGjn68AAAIESgJGv3RtWQkQyAsY/XwFABAgUBIw+qVry0qAQF7A6OcrAIAAgZKA0S9dW1YCBPICRj9fAQAECJQEjH7p2rISIJAXMPr5CgAgQKAkYPRL15aVAIG8gNHPVwAAAQIlAaNfurasBAjkBYx+vgIACBAoCRj90rVlJUAgL2D08xUAQIBASeA1+se/71nrs5RbVgIECCQFbtv1CQFemq4aUXQEAAAAAElFTkSuQmCC);
      border: none !important;
      padding: 10px;

      &:hover {
        background: rgba(11, 111, 155, 0.6);
      }
      &.hilight {
        background: #0b6f9b;
      }
      .item {
        font-size: 18px;
        /* padding-left: 14px; */
        padding: 10px;
      }
    }
    .swiper-slide {
      display: block;
      text-align: initial;
      height: auto !important;
    }
  }
`;
type SwiperTableProps = {
  columns: ColumnsType<any>;
  dataSource: readonly any[];
  slidesPerView: number;
  onClick?: (record: any) => void;
  className?: string;
  slidesHeight: number;
};
export const SwiperTable: React.FC<SwiperTableProps> = (props) => {
  const {
    columns,
    slidesPerView,
    slidesHeight,
    dataSource = [],
    onClick = () => {},
    className,
  } = props;
  const colSpanCount = columns.reduce((init, item) => {
    if (item.colSpan) {
      init += item.colSpan;
    }
    return init;
  }, 0);
  const span =
    (24 - colSpanCount) / columns.filter((item) => !item.colSpan).length;
  return (
    <SwiperTableLayout>
      <div className="swiper-table">
        <Row className="header" gutter={24}>
          {columns.map((colItem) => (
            <Col span={colItem.colSpan || span}>
              <>{colItem.title}</>
            </Col>
          ))}
        </Row>
        <div style={{ height: slidesHeight }}>
          <Swiper
            slidesPerView={slidesPerView}
            spaceBetween={0}
            autoplay={{
              delay: 2000,
              // disableOnInteraction: false,
            }}
            loop={false}
            pagination={{
              clickable: true,
            }}
            onActiveIndexChange={(swiper) => {
              console.log(swiper.realIndex);
            }}
            // navigation={true}
            direction={"vertical"}
            modules={[Autoplay]}
            // modules={[Pagination, Navigation]}
            //   className="mySwiper"
          >
            {dataSource.map((item, index) => {
              // if (index > 8) return null;
              return (
                <SwiperSlide>
                  <Row
                    className={`body ${index % 2 ? "hilight" : ""}`}
                    onClick={(e) => {
                      onClick?.(item);
                    }}
                  >
                    {columns.map((colItem: any, suIndex) => {
                      return (
                        <Col
                          className="item"
                          span={colItem.colSpan || span}
                          //   style={{ paddingLeft: suIndex === 0 ? 14 : "0" }}
                        >
                          <>
                            {colItem.render
                              ? colItem.render(
                                  item[colItem.dataIndex],
                                  item,
                                  index
                                )
                              : item[colItem.dataIndex]}
                          </>
                        </Col>
                      );
                    })}
                  </Row>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </SwiperTableLayout>
  );
};
